export const EEII_TABLE_COLUMNS = [
  { field: 'fecha_alta_ap', align: 'left', width: 140, type: 'date' },
  {
    field: 'nombre_eeii',
    align: 'left',
    cellStyle: {
      textTransform: 'capitalize',
    },
  },
  { field: 'zonas_servicio', align: 'left' },
  {
    field: 'cif_eeii',
    align: 'left',
    width: 120,
    cellStyle: {
      textTransform: 'uppercase',
    },
  },
  { field: 'telefono_eeii', align: 'left', width: 120 },
  { field: 'email_eeii', align: 'left' },
  {
    field: 'nombre_gremio',
    align: 'left',
    cellStyle: {
      textTransform: 'capitalize',
    },
  },
  { field: 'publica_portal_cliente', align: 'left', width: 40, infoType: 'logic' },
  { field: 'numero_demandas', align: 'left', width: 40 },
  { field: 'numero_solicitudes', align: 'left', width: 40 },
  { field: 'numero_demandas_zona', align: 'left', width: 40 },
  { field: 'numero_solicitudes_zona', align: 'left', width: 40 },
  { field: 'tiene_tarifas', align: 'left', width: 40, infoType: 'logic' },
  { field: 'valoracion_media', align: 'left', width: 40, infoType: 'toRound' },
]

export const EEII_TABLE_FILTERS = [
  {
    name: 'gremio_id',
    comboId: 'guilds',
    size: 'small',
    filterType: 'autocomplete',
  },
  {
    name: 'comunidad_autonoma',
    comboId: 'cod_zona_zeus',
    size: 'small',
    multiple: true,
  },
  {
    name: 'tiene_tarifas',
    filterType: 'switch',
    cleanSelf: true,
  },
  {
    name: 'publica_portal_cliente',
    filterType: 'switch',
    cleanSelf: true,
  },
]
